export type LoginLandingVariantKey =
	| 'ai-creative-suite';

export interface LoginLandingVariantLogo {
	id: number;
	name: string;
	src: string;
}

export interface LoginLandingVariant {
	key: LoginLandingVariantKey;
	defaultWindowView?: 'signup' | 'login';
	showLogoMarquee?: boolean;
	logoMarqueeBackgroundColorHex?: string;
	logoMarqueeTagline?: string;
	signUpCtaText?: string;
	signUpPromoText?: string;
	leftPanel: {
		headline: string;
		description: string;
		bullets: string[];
	};
}

export const LOGIN_LANDING_VARIANTS: Record<LoginLandingVariantKey, LoginLandingVariant> = {
	'ai-creative-suite': {
		key: 'ai-creative-suite',
		defaultWindowView: 'signup',
		showLogoMarquee: true,
		logoMarqueeBackgroundColorHex: '#171717',
		logoMarqueeTagline: "Trusted by the world's leading creative teams",
		signUpCtaText: 'Create Free Account',
		signUpPromoText: 'Get started for Free (No Credit Card Required)',
		leftPanel: {
			headline: 'Scale Brand DNA. Eliminate Creative Risk',
			description: 'Run Diffusion is the leading Generative AI platform for Creative Teams, engineered for brand-safe production. Unify your creative team workflow with private, brand-trained models, full productivity workflows, and granular asset control. Stop fighting generic outputs. Start scaling your signature style.',
			bullets: [
				'Secure, studio-grade project workspaces for creative teams',
				'Enterprise-scale Creative Operations (CreativeOps).',
				'Centralized IP and custom model management.',
			],
		},
	},
};

export function getLoginLandingVariant (rawKey: unknown): LoginLandingVariant | null {
	if (typeof rawKey !== 'string') return null;

	const key = rawKey.trim().toLowerCase() as LoginLandingVariantKey;
	return LOGIN_LANDING_VARIANTS[key] || null;
}

